import VersionUpdateModal from './VersionUpdateModal';

export default VersionUpdateModal;
